// extracted by mini-css-extract-plugin
export default {"Dropdown":"MentionDropdown_Dropdown__6Lig3","Option":"MentionDropdown_Option__hnJRx"};